module.exports = __webpack_public_path__ + "static/media/closeicon-white.9f22e01a.svg";